import React from 'react';
import { Box, Container, Flex, Spinner, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import NavBar from 'Components/element/NavBar';
import Footer from 'Components/element/Footer';
import { useRAuth } from './r-auth.provider';

const RAuthView = () => {
   const store = useRAuth();
   const navigate = useNavigate();
   const { token } = useParams<{ token: string }>();
   const [invalidToken, setInvalidToken] = React.useState(false);
   const authorizationStarted = React.useRef(false);

   React.useEffect(() => {
      if (authorizationStarted.current) {
         return;
      }

      authorizationStarted.current = true;

      if (!token) {
         navigate('/');
         return;
      }

      store.authorize(token, {
         onSuccess: (response) => {
            const redirectTo =
               response.response.user.user_type === 'recruiter' ? '/user/myprofile' : '/candidate/my-cv-list';

            navigate(redirectTo);
         },
         onError: (message, status) => {
            if (status === 403 || status === 404) {
               setInvalidToken(true);
               return;
            }

            toast.error(message || 'Redirect authorization failed');
         },
      });
   }, [navigate, store, token]);

   return (
      <>
         <NavBar />
         <Container size="4" py="9">
            <Box maxHeight="200px" height="200px" width="100%">
               {store.authorizing && !invalidToken && (
                  <Flex height="100%" align="center" justify="center" aria-busy="true">
                     <Spinner size="3" />
                  </Flex>
               )}

               {invalidToken && (
                  <Flex height="100%" align="center" justify="center">
                     <Text size="5" weight="medium" color="red">
                           Помилка авторизації
                     </Text>
                  </Flex>
               )}
            </Box>
         </Container>
         <Footer />
      </>
   );
};

export const RAuth = observer(RAuthView);
